import apiClient from 'ps-components/lib/apiClient';

import { addMatch, deleteMatch } from '../MarketPricingActions';

export const GET_SURVEY_JOB_DATA_CUT_START = 'GET_SURVEY_JOBS_DATA_CUT_START';
export const GET_SURVEY_JOB_DATA_CUT_SUCCESS = 'GET_SURVEY_JOBS_DATA_CUT_SUCCESS';
export const GET_SURVEY_JOB_DATA_CUT_ERROR = 'GET_SURVEY_JOBS_DATA_CUT_ERROR';
export const SAVE_DATA_CUT_CHANGES_START = 'SAVE_DATA_CUT_CHANGES_START';
export const SAVE_DATA_CUT_CHANGES_SUCCESS = 'SAVE_DATA_CUT_CHANGES_SUCCESS';
export const SAVE_DATA_CUT_CHANGES_ERROR = 'SAVE_DATA_CUT_CHANGES_ERROR';
export const SAVE_DATA_CUT_CHANGES_RESET = 'SAVE_DATA_CUT_CHANGES_RESET';

export function resetSurveyJobDataCuts() {
  return { type: SAVE_DATA_CUT_CHANGES_RESET };
}

export function getSurveyJobDataCuts(surveyCode, surveyJobCode, currency = null) {
  return async dispatch => {
    try {
      dispatch({ type: GET_SURVEY_JOB_DATA_CUT_START });
      const dataCutsResult = await apiClient.apiPost('/api/market-pricing/data-cuts/surveyJobDataCuts', {
        surveyCode,
        surveyJobCode,
        currency
      });
      dispatch({ type: GET_SURVEY_JOB_DATA_CUT_SUCCESS, dataCuts: dataCutsResult.data.dataCuts });
      return dataCutsResult.data.dataCuts;
    } catch (e) {
      dispatch({ type: GET_SURVEY_JOB_DATA_CUT_ERROR });
      throw e;
    }
  };
}

export function saveDataCutChanges(job, addDataCutIds, deleteDataCutIds, benchmarkYear, displayIn) {
  return async dispatch => {
    try {
      dispatch({ type: SAVE_DATA_CUT_CHANGES_START });
      const promises = [];
      if (addDataCutIds.length > 0) {
        promises.push(dispatch(addMatch(job.id, addDataCutIds, null, false, benchmarkYear, null)));
      }
      if (deleteDataCutIds.length > 0) {
        promises.push(dispatch(deleteMatch(job.id, deleteDataCutIds, null, benchmarkYear, false, null)));
      }
      return await Promise.all(promises)
        .then(async () => {
          dispatch({ type: SAVE_DATA_CUT_CHANGES_SUCCESS });
          return;
        })
        .catch(e => {
          throw e;
        });
    } catch (e) {
      dispatch({ type: SAVE_DATA_CUT_CHANGES_ERROR });
      throw e;
    }
  };
}
